import React from "react";
import { graphql, useFragment } from "react-relay";
import {
  LINKED_ITEM_CONTAINER_HEIGHT,
  LinkedItemContainer,
} from "./LinkedItemContainer";

import { LinkedImageItem_image$key } from "./__generated__/LinkedImageItem_image.graphql";
import { ColorType, Image } from "arkh";

export function LinkedImageItem(props: {
  image: LinkedImageItem_image$key;
  onRemove?: (id: string) => void;
  openImage: (id: string) => void;
  borderColor?: ColorType;
  disabled?: boolean;
}) {
  const image = useFragment(
    graphql`
      fragment LinkedImageItem_image on Image {
        id

        ...Image_image
      }
    `,
    props.image
  );
  return (
    <LinkedItemContainer
      disabled={props.disabled}
      onPress={() => {
        props.openImage(image.id);
      }}
      onRemove={
        props.onRemove
          ? () => {
              props.onRemove?.(image.id);
            }
          : undefined
      }
      space="none"
      borderColor={props.borderColor}
    >
      <Image
        image={image}
        type="remote"
        style={{
          width: LINKED_ITEM_CONTAINER_HEIGHT,
          height: LINKED_ITEM_CONTAINER_HEIGHT,
        }}
      />
    </LinkedItemContainer>
  );
}
